import React from "react";

const DeleteIcon = ({ color, onClick }) => {
  return (
    <svg 
      onClick={onClick}
      style={{ color, cursor: 'pointer' }}
      width="18" 
      height="18" 
      viewBox="0 0 25 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M3.94882 6.00354L5.94882 6.00278M5.94882 6.00278L21.9488 5.99667M5.94882 6.00278L5.95417 20.0028C5.95437 20.5332 6.16528 21.0418 6.5405 21.4168C6.91571 21.7917 7.4245 22.0022 7.95493 22.002L17.9549 21.9982C18.4854 21.998 18.994 21.7871 19.3689 21.4119C19.7439 21.0367 19.9544 20.5279 19.9542 19.9974L19.9488 5.99743M8.94882 6.00163L8.94806 4.00163C8.94786 3.4712 9.15838 2.96241 9.53331 2.58719C9.90824 2.21198 10.4169 2.00107 10.9473 2.00087L14.9473 1.99934C15.4777 1.99914 15.9865 2.20966 16.3617 2.58459C16.7369 2.95952 16.9479 3.46814 16.9481 3.99858L16.9488 5.99858M10.9507 11.0009L10.953 17.0009M14.9507 10.9993L14.953 16.9993" 
        stroke={color ?? "primary"} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
